import { gql} from '@apollo/client';

export const RETRIEVE_STATIC_PAGE = gql`
  query staticPages($name: String!) {
    getByPage(page:$name) {
      content
      title
    }
  }`;
